export const paintingHouses = [
  {
    id: 1,
    imgBefore: "images/painting-1a.png",
    imgAfter: "images/painting-1b.png",
    description: "Wooden House",
  },
  {
    id: 2,
    imgBefore: "images/painting-2a.png",
    imgAfter: "images/painting-2b.jpg",
    description: "Stairs",
  },
  {
    id: 3,
    imgBefore: "images/painting-3a.jpg",
    imgAfter: "images/painting-3b.jpg",
    description: "Bedroom",
  },
  {
    id: 4,
    imgBefore: "images/painting-4a.jpg",
    imgAfter: "images/painting-4b.jpg",
    description: "Brick House",
  },
  {
    id: 5,
    imgBefore: "images/painting-5a.jpg",
    imgAfter: "images/painting-5b.jpg",
    description: "Kitchen",
  },

  {
    id: 6,
    imgBefore: "images/painting-6a.jpg",
    imgAfter: "images/painting-6b.jpg",
    description: "Dining Room",
  },

  {
    id: 7,
    imgBefore: "images/painting-7a.png",
    imgAfter: "images/painting-7b.png",
    description: "Stairs",
  },
];

export const carouselPhotos = [
  {
    id: 1,
    imgCarousel: "images/house-1.jpg",
  },
  {
    id: 2,
    imgCarousel: "images/house-2.jpg",
  },
  {
    id: 3,
    imgCarousel: "images/house-3.jpg",
  },
  {
    id: 4,
    imgCarousel: "images/house-4.jpg",
  },
  {
    id: 5,
    imgCarousel: "images/house-5.jpg",
  },
  {
    id: 6,
    imgCarousel: "images/house-6.jpg",
  },
  {
    id: 7,
    imgCarousel: "images/house-7.jpg",
  },
  {
    id: 8,
    imgCarousel: "images/house-8.jpg",
  },
  {
    id: 9,
    imgCarousel: "images/house-9.jpg",
  },
  {
    id: 10,
    imgCarousel: "images/house-10.jpg",
  },
  {
    id: 11,
    imgCarousel: "images/house-11.jpg",
  },
  {
    id: 12,
    imgCarousel: "images/house-12.jpg",
  },
  {
    id: 13,
    imgCarousel: "images/house-13.jpg",
  },
];

export const team = [
  {
    id: 1,
    firstname: "Frants",
    lastname: "Elliassaint",
    photo: "images/team-members/member-2.jpg",
    position: "CEO, Founder & Painter",
    facebooLink: "https://www.facebook.com/trucolour.painting.1",
  },
  {
    id: 2,
    firstname: "Samuel",
    lastname: "Cornet",
    photo: "images/team-members/member-1.jpg",
    position: "CO Founder",
    facebooLink: "https://www.facebook.com/samuel.cornet",
  },
  {
    id: 3,
    firstname: "Nadia",
    lastname: "Salien",
    photo: "images/team-members/member-3.jpg",
    position: "Accountant",
    facebooLink: "https://www.facebook.com/samuel.cornet",
  },
];
